// this limit does not include the "other" slice
export const FIELD_LIMIT = 7;
